class Mapper {
  protected importMapper: (pageTemplate: string) => Promise<any>;

  setMapper(importMapper: (pageTemplate: string) => Promise<any>): void {
    this.importMapper = importMapper;
  }
}

export default Mapper;
